import { useQuery } from "@apollo/client";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, CircularProgress, Link, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import IllustrationEditFormCont from "../containers/IllustrationEditFormCont";
import { QUERY_ILLUSTRATION } from "../gql/queries/illustration";
import { truncateWithEllipses } from "../helpers/utils";
import { Spacing } from "../types/enum";

const IllustrationsEditPage: React.FC = () => {
  const params = useParams<Record<string, string>>();

  const { data, loading } = useQuery(QUERY_ILLUSTRATION, {
    fetchPolicy: "network-only",
    variables: {
      id: params?.illustrationId,
    },
  });

  if (loading) {
    return <CircularProgress />;
  }

  const illustration = data?.adminGetIllustration;

  return (
    <>
      <Box display="flex" alignItems="center" mb={Spacing.m}>
        <Link color="inherit" component={RouterLink} to="/illustrations">
          <Box mr={Spacing.sm}>
            <ArrowBackIcon />
          </Box>
        </Link>

        <Typography variant="h3" color="textPrimary">
          {truncateWithEllipses(illustration?.title)}
        </Typography>
      </Box>

      <IllustrationEditFormCont illustration={illustration} />
    </>
  );
};

export default IllustrationsEditPage;
